package br.com.texeratx.boardgametimeapp.core.storage

actual fun getPlatformTokenStorage(): TokenStorage =
    TokenStorageJs()
